import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin
} from "antd";
import { Component } from "react";
import "../styles/general.css";

import { GET, UPDATE } from "../constants/request-type";
import {
  admin,
  get_all_permission,
  permission,
  update_admin,
  update_password_admin
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";
import { uploadFile } from "../functions/upload-file";
import {
  EmailValidation,
  PasswordValidation
} from "../functions/validateEmailPassword";

const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Admin_edit extends Component {
  state = {
    visible: false,
    firstname: this.props.row.firstname,
    lastname: this.props.row.lastname,
    number: this.props.row.number,
    email: this.props.row.email,
    password: "",
    c_password: "",
    gender: this.props.row.gender,
    birthdate: this.props.row.birthdate,
    pic: null,
    list: [],
    permission: this.props.row.permission._id,
    status: 1,
    load: true
  };

  componentDidMount() {
    this.getData();
  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageChange = (e) => {
    e.preventDefault();
    return this.setState({ pic: e.target.files[0] });
  };
  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: permission + "/" + get_all_permission,
      data: null,
      token: token
    };
    try {
      const response = await MakeRequestAsync(request_details);
      this.setState({
        list: decryptSingleData(response.data.permission),
        load: false
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon("err", err);
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const {
      firstname,
      lastname,
      email,
      number,
      password,
      c_password,
      gender,
      birthdate,
      pic,
      permission
    } = this.state;

    const data = {
      firstname: firstname.toLowerCase(),
      lastname: lastname.toLowerCase(),
      email: email.toLowerCase(),
      number,
      permission,
      gender,
      birthdate
    };

    const request_details_password = {
      type: UPDATE,
      url: service_api,
      route: admin + "/" + update_password_admin + "/" + this.props.row._id,
      data: data,
      token: token
    };

    if (!EmailValidation(email)) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Veuillez entrer un email valide"
      );
    }
    if (password !== "") {
      if (!PasswordValidation(password)) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          "Veuillez entrer un mot de passe (fort) A-a-z0-9"
        );
      }
      if (password !== c_password) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          "Veuillez entrer le même mot de passe"
        );
      }

      try {
        await MakeRequestAsync(request_details_password);
      } catch (err) {
        this.setState({ load: false });
        return openNotificationWithIcon("error", err);
      }
    }

    if (
      firstname === "" ||
      lastname === "" ||
      number === "" ||
      permission === "" ||
      !gender ||
      !birthdate
    ) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tous les champs"
      );
    }

    let pic_url;

    if (pic !== null) {
      pic_url = await uploadFile(pic);
      if (!pic_url.data.success) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          "Nous n'avons pas pu télécharger votre image"
        );
      }
    }

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: admin + "/" + update_admin + "/" + this.props.row._id,
      data: {
        ...data,
        pic: pic !== null ? pic_url.data.url : this.props.row.pic
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const {
      firstname,
      lastname,
      email,
      number,
      permission,
      password,
      c_password,
      pic,
      gender,
      birthdate,
      list,
      load
    } = this.state;
    return (
      <>
        <Button type="danger" onClick={this.showDrawer}>
          Modifier
        </Button>
        <Drawer
          title="Modification de compte administrateur"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Nom"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer le nom de l'administrateur"
                    }
                  ]}
                >
                  <Input
                    name="firstname"
                    placeholder="Veuillez entrer le nom"
                    onChange={this.handleChange}
                    value={firstname}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Prénom"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer le prénom de l'administrateur"
                    }
                  ]}
                >
                  <Input
                    name="lastname"
                    placeholder="Veuillez entrer le prénom"
                    onChange={this.handleChange}
                    value={lastname}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Email"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer l'email de l'administrateur"
                    }
                  ]}
                >
                  <Input
                    name="email"
                    placeholder="Veuillez entrer l'email"
                    onChange={this.handleChange}
                    value={email}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Contact"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer le contact de l'administrateur"
                    }
                  ]}
                >
                  <Input
                    name="number"
                    placeholder="Veuillez entrer le contact"
                    onChange={this.handleChange}
                    value={number}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Date de naissance"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer la date de naissance"
                    }
                  ]}
                >
                  <input
                    style={{
                      width: "100%",
                      border: "1px solid #cecece"
                    }}
                    type="date"
                    name="birthdate"
                    placeholder="Veuillez entrer la date de naissance"
                    onChange={this.handleChange}
                    value={birthdate}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Genre"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez selectionner le genre"
                    }
                  ]}
                >
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Selectionner parmis les options"
                    defaultValue={gender}
                    onChange={(data) => {
                      return this.setState({ gender: data });
                    }}
                  >
                    {[
                      {
                        _id: "male",
                        name: "Homme"
                      },
                      {
                        _id: "female",
                        name: "Femme"
                      },
                      {
                        _id: "other",
                        name: "Autre"
                      }
                    ].map((item) => (
                      <Option key={item?._id}>
                        <span>{item?.name}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="password"
                  label="Mot de passe"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer le mot de passe de l'administrateur"
                    }
                  ]}
                >
                  <Input
                    name="password"
                    type="password"
                    placeholder="Veuillez entrer le mot de passe"
                    onChange={this.handleChange}
                    value={password}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="c_password"
                  label="Confirmer Mot de passe"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez confimer le mot de passe de l'administrateur"
                    }
                  ]}
                >
                  <Input
                    name="c_password"
                    type="password"
                    placeholder="Veuillez confirmer le mot de passe"
                    onChange={this.handleChange}
                    value={c_password}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="pic"
                  label="Photo profile"
                  rules={[
                    {
                      required: true,
                      message: "Upload is required"
                    }
                  ]}
                >
                  <Input
                    type="file"
                    accept="image/x-png,image/jpeg,image/jpg"
                    placeholder="Upload picture"
                    onChange={this.handleImageChange}
                    value={pic}
                    name="pic"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Permission"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez selectionner le genre"
                    }
                  ]}
                >
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Selectionner parmis les options"
                    defaultValue={permission}
                    onChange={(data) => {
                      return this.setState({ permission: data });
                    }}
                  >
                    {list.map((item) => (
                      <Option key={item._id}>
                        <span>{item.name}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Admin_edit;
